<template>
    <Carousel ref="carouselRef" :mouse-drag="false" :itemsToShow="3" :breakpoints="breakpoints" :transition="800">
        <template #default>
            <slot></slot>
        </template>

        <template #addons="{ currentSlide, slidesCount, goToSlide }">
            <div v-if="showControls" class="mt-4 flex justify-center items-center gap-2.5">
                <button
                    class="group w-10 h-10 rounded-full border-2 border-[#2459A8] laptop:hover:bg-[#2459A8] mobile:bg-[#2459A8] laptop:bg-white disabled:hover:bg-transparent disabled:bg-white disabled:border-[#CCCCCC] disabled:focus-visible:border-[#CCCCCC] disabled:bg-[#EFEFEF] flex items-center justify-center"
                    @click="prevSlide"
                    :disabled="currentSlide === 0">
                    <font-awesome-icon icon="arrow-left" class="w-5 h-5 mobile:text-white laptop:text-[#2459A8] laptop:group-hover:text-white group-disabled:bg-transparent group-disabled:!text-[#CCCCCC] group-disabled:focus:!text-[#CCCCCC]" />
                </button>
                <customSliderPagination :currentSlide="currentSlide" :slidesCount="slidesCount"
                    @go-to-slide="goToSlide" />
                <button
                    class="group w-10 h-10 rounded-full border-2 border-[#2459A8] laptop:hover:bg-[#2459A8] mobile:bg-[#2459A8] laptop:bg-white disabled:hover:bg-transparent disabled:bg-white disabled:border-[#CCCCCC] disabled:bg-[#EFEFEF] flex items-center justify-center"
                    @click="nextSlide"
                    :disabled="currentSlide === slidesCount - 1">
                    <font-awesome-icon icon="arrow-right" class="w-5 h-5 mobile:text-white laptop:text-[#2459A8] laptop:group-hover:text-white group-disabled:bg-transparent group-disabled:!text-[#CCCCCC] group-disabled:focus:!text-[#CCCCCC]" />
                </button>
            </div>
        </template>
    </Carousel>
</template>

<script>
import { Carousel } from 'vue3-carousel';
import 'vue3-carousel/dist/carousel.css';
import customSliderPagination from './customSliderPagination.vue';

export default {
    props: ['length'],
    components: { Carousel, customSliderPagination },

    data() {
        return {
            windowWidth: window.innerWidth,
            observer: null,
            breakpoints: {
                1440: { itemsToShow: 2, wrapAround: false, snapAlign: 'start' },
                1025: { itemsToShow: 2, wrapAround: false, snapAlign: 'start' },
                1024: { itemsToShow: 1, wrapAround: false, snapAlign: 'start' },
                600: { itemsToShow: 1, wrapAround: false, snapAlign: 'start' },
                300: { itemsToShow: 1, wrapAround: false, snapAlign: 'start' }
            }
        };
    },

    computed: {
        isMobileOrTablet() {
            return this.windowWidth <= 1366;
        },

        showControls() {
            if (this.windowWidth > 1439) {
                return this.length > 2;
            } else if (this.windowWidth > 1024 && this.windowWidth <= 1439) {
                return this.length > 2;
            } else {
                return this.length > 1;
            }
        }
    },

    mounted() {
        this.handleResize = this.handleResize.bind(this);
        window.addEventListener('resize', this.handleResize);

        const wrapper = this.$el.querySelector('.carousel__track'); // Adjust based on DOM structure
        if (wrapper) {
            this.observer = new ResizeObserver((entries) => {
                entries.forEach((entry) => {
                    if (this.$refs.carouselRef?.updateSlideWidth) {
                        this.$refs.carouselRef.updateSlideWidth();
                    }
                });
            });
            this.observer.observe(wrapper);
        }
    },

    beforeUnmount() {
        window.removeEventListener('resize', this.handleResize);
        if (this.observer) this.observer.disconnect();
    },

    methods: {
        prevSlide() {
            this.$refs.carouselRef?.prev();
        },
        nextSlide() {
            this.$refs.carouselRef?.next();
        },
        handleResize() {
            this.windowWidth = window.innerWidth;
        }
    }
};
</script>
